import React, { useEffect, useRef, useState } from "react";
import FireOnMenu from "./FireOnMenu";
import DashboardMenu from "./DashboardMenu";
import { useLocation, useNavigate, useParams } from "react-router-dom";
import { apiWrapper } from "../../apis/CommonApi";
import * as fireonApi from "../../apis/FireOnApi";
import PageHeader from "../PageHeader";

export default function FireEquipmentStatusComponent() {
  const itemsPerPage = 100;
  const navigate = useNavigate();
  const { id } = useParams();
  const location = useLocation();
  const { buildingName } = location.state;
  const [dataSource, setDataSource] = useState([]);
  const [page, setPage] = useState(1);
  const [next, setNext] = useState(null);
  const scrollRef = useRef();
  const pageRef = useRef(page);
  const nextRef = useRef(next);

  useEffect(() => {
    const scrollWrap = scrollRef.current;

    const handleScroll = () => {
      if (
        scrollWrap.scrollTop + scrollWrap.clientHeight >=
        scrollWrap.scrollHeight - 5
      ) {
        if (nextRef.current) {
          getData(pageRef.current + 1);
        }
      }
    };

    scrollWrap.addEventListener("scroll", handleScroll);

    console.log(page);
    getData(page);

    return () => {
      scrollWrap.removeEventListener("scroll", handleScroll);
    };
  }, []);

  useEffect(() => {
    pageRef.current = page;
  }, [page]);

  useEffect(() => {
    nextRef.current = next;
  }, [next]);

  const getData = (page) => {
    apiWrapper(async () => {
      const result = await fireonApi.getFireFightingFacilityList(
        id,
        page,
        itemsPerPage
      );

      const { status, data } = result;
      if (status === true) {
        setDataSource((prevDataSource) => {
          if (prevDataSource.some((item) => item.page === page)) {
            return prevDataSource;
          }

          return [
            ...prevDataSource,
            {
              page: page,
              results: data.results,
            },
          ];
        });

        setNext(data.next);
        setPage(page);
      } else {
        alert(`${data}`);
      }
    });
  };

  const handleItemClick = (equipmentId) => {
    navigate(`/fire-on/fire-equipment-status/${id}/detail/${equipmentId}`, {
      state: location.state,
    });
  };

  return (
    <section id="darkMode" class="mbSection darkMode">
      <PageHeader isBlack={true} title={buildingName} isUseMenu={true} />
      <div class="container">
        <p class="tableTitle mt-24">소방설비현황</p>
        <div class="tableList FESlist">
          <div ref={scrollRef} class="config-row-wrap">
            {dataSource.length > 0 &&
              dataSource.map((pageItem) => {
                if (pageItem.results.length > 0) {
                  return pageItem.results.map((item, index) => (
                    <div
                      class="config-row"
                      onClick={() => handleItemClick(item.id)}
                    >
                      <div class="config-number">
                        <p class="row-num">{item.id}</p>
                      </div>
                      <div class="config-info">
                        <div class="info-title">
                          <p class="title-txt">{item.installationFloor}</p>
                          <span class="divi"></span>
                          <p class="title-txt">{item.detailedLocation}</p>
                        </div>
                        <div class="info-equipment">
                          <p class="eq-txt eq-category">{item.category}</p>
                          <span class="divi"></span>
                          <p class="eq-txt eq-name">{item.name}</p>
                        </div>
                        <div class="info-install">
                          <p class="ins-txt ins-title">설치일자&nbsp;:&nbsp;</p>
                          <p class="ins-txt ins-date">
                            {item.installationDate}
                          </p>
                        </div>
                      </div>
                      <div class="config-status">
                        <div class="wrap_state_item">
                          <p class="title_state" style={{ paddingLeft: "5px" }}>
                            {item.operationalStatus}
                          </p>
                        </div>
                      </div>
                    </div>
                  ));
                }
              })}
          </div>
        </div>
      </div>
      <div id="dashboardMenu" class="active_05">
        <DashboardMenu buildingName={buildingName} />
      </div>
      <FireOnMenu />
    </section>
  );
}
